/**
 * Klucze zapytań modułu zmian rezerwacji.
 *
 * Wszystko, co dotyczy jednej rezerwacji, wisi pod `['booking-changes', bookingId]`,
 * dzięki czemu po każdej mutacji szkicu wystarczy unieważnić jeden prefiks.
 */
export const bookingChangesApiQueryKeys = {
  all: () => ['booking-changes'] as const,
  booking: (bookingId: string) => ['booking-changes', bookingId] as const,
  /** Lista paczek rezerwacji — historia, numer paczki i wyszukanie otwartej. */
  changes: (bookingId: string) =>
    ['booking-changes', bookingId, 'list'] as const,
  /** Szczegóły jednej paczki — pozycje, których lista nie niesie. */
  change: (bookingId: string, changeId: string) =>
    ['booking-changes', bookingId, 'change', changeId] as const,
  openDraft: (bookingId: string) =>
    ['booking-changes', bookingId, 'draft'] as const,
  preview: (bookingId: string, changeId: string) =>
    ['booking-changes', bookingId, 'change', changeId, 'preview'] as const,
  schedulePreview: (bookingId: string, changeId: string) =>
    ['booking-changes', bookingId, 'change', changeId, 'schedule'] as const,
  publicChange: (orgSlug: string, token: string) =>
    ['booking-changes', 'public', orgSlug, token] as const,
  /** Podgląd rezygnacji zależy od wyboru osób i potrącenia, więc oba są w kluczu. */
  withdrawalPreview: (bookingId: string, request: string) =>
    ['booking-changes', bookingId, 'withdrawal-preview', request] as const,
};
